import { render } from "./BannerSlotDetailPreviewBannerSlot.vue?vue&type=template&id=05b5eaf7&scoped=true&ts=true"
import script from "./BannerSlotDetailPreviewBannerSlot.vue?vue&type=script&lang=ts"
export * from "./BannerSlotDetailPreviewBannerSlot.vue?vue&type=script&lang=ts"

import "./BannerSlotDetailPreviewBannerSlot.vue?vue&type=style&index=0&id=05b5eaf7&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b5eaf7"]])

export default __exports__